export default __webpack_public_path__ + "static/media/Northrop_Grumman.e77edf30.png";